import { dateFunc } from "@/components/Functions/dateFunc";
import { getStatusDescription } from "@/utility/common";
import { useTranslation } from "react-i18next";

export const useColumnDistribution = (timeZone: string) => {
  const { t } = useTranslation();
  return [
    {
      cellRenderer: "distributionName",
      comparator: () => 0,
      field: "name",
      type: "nameType",
      headerName: t(
        "pages.distributions.distribution.tableColumnDetails.column1"
      ),
      sortable: true,
      unSortIcon: true,
      cellClass: "align-left text-bold",
      headerClass: "align-left",
      flex: 1,
      wordWrap: true,
      autoHeight: true,
      minWidth: 150,
    },
    {
      comparator: () => 0,
      field: "distributionStatus",
      type: "distributionStatusType",
      cellRenderer: function (params: any) {
        return getStatusDescription(params.data.distributionStatus);
      },
      headerName: t(
        "pages.distributions.distribution.tableColumnDetails.column2"
      ),
      sortable: true,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
      flex: 1,
      minWidth: 100,
    },
    {
      cellRenderer: function (params: any) {
        return dateFunc(params.data.distributionDate).formattedDateOnly;
      },
      comparator: () => 0,
      field: "distributionDate",
      type: "distributionDateType",
      headerName: t(
        "pages.distributions.distribution.tableColumnDetails.column3"
      ),
      cellClass: "align-left",
      headerClass: "align-left",
      sortable: true,
      unSortIcon: true,
      flex: 1,
      wordWrap: true,
      autoHeight: true,
      minWidth: 130,
    },
    {
      cellRenderer: function (params: any) {
        return dateFunc(params.data.effectiveDate).formattedDateOnly;
      },
      comparator: () => 0,
      field: "effectiveDate",
      type: "effectiveDateType",
      headerName: t(
        "pages.distributions.distribution.tableColumnDetails.column4"
      ),
      cellClass: "align-left",
      headerClass: "align-left",
      sortable: true,
      unSortIcon: true,
      flex: 1,
      wordWrap: true,
      autoHeight: true,
      minWidth: 120,

      // headerComponent:CustomHeaderImport
    },
    {
      cellRendererParams: {
        timeZoneName: timeZone,
      },
      cellRenderer: function (params: any) {
        return (
          dateFunc(params.data.createdOn).formattedDateTime +
          " " +
          params.timeZoneName
        );
      },
      comparator: () => 0,
      field: "createdOn",
      type: "createdOnType",
      headerName: t(
        "pages.distributions.distribution.tableColumnDetails.column5"
      ),
      cellClass: "align-left",
      headerClass: "align-left",
      sortable: true,
      unSortIcon: true,
      flex: 1,
      wordWrap: true,
      autoHeight: true,
      minWidth: 160,
    },
    {
      flex: 1,
      minWidth: 160,
      cellRenderer: "actionCellRenderers",
      field: "action",
      headerName: "",
      sortable: false,
      cellClass: "align-right",
    },
  ];
};
